import { VLazyImagePlugin } from 'v-lazy-image'
import Vue from 'vue'
import VModal from 'vue-js-modal'
import RModal from '@/plugins/modal'
import Notifications from 'vue-notification'
import { app } from './app'
import MainApp from './MainApp.vue'
import router from './router'
import store from './store/root'
import { errorHandler } from '@/services/errors'
import VueHead from 'vue-head'
import * as Sentry from '@sentry/browser'

Vue.use(VueHead)
Vue.use(VModal)
Vue.use(RModal)
Vue.use(Notifications)
Vue.use(VLazyImagePlugin)
Vue.config.productionTip = false

// Error handling:
// only when the errorHandler is present, Vue propagates errors to the window.
// https://www.raymondcamden.com/2019/05/01/handling-errors-in-vuejs
Vue.config.errorHandler = errorHandler
window.onerror = function (message, source, line, column, error) {
  Sentry.captureException(error)
  alert('Please refresh the tab to get latest update')
  window.location.reload()
}

let initialized = false

app.auth().onAuthStateChanged(() => {
  if (!initialized) {
    initialized = true
    new Vue({
      router,
      store,
      render: (h) => h(MainApp),
    }).$mount('#app')
  }
})
